<template>
  <div class="videoresume-wrapper">
    <vresume-success v-show="localesLoaded" :link="link" @submit="submit"/>
  </div>
</template>

<script>
import axios from 'axios';

import store from '@/stores_new/interview_new/index.js';
const STORE_PREFIX = 'VIDEORESUME';

export default {
  name: 'EndVideoresume',
  props: ['token'],
  data() {
    return {
      link: `http://${window.location.host}/p/`
    }
  },
  computed: {
    ...mapGetters(STORE_PREFIX + 'interview', {
      videoResponse: 'response',
      interview: 'item'
    }),
    localesLoaded () {
      return this.$store.getters['services/localesLoaded'];
    }
  },
  methods: {
    submit(model) {
      axios.post(`/public/v2/interviews/${this.token}/feedback`, {
        text: model.text,
        value: model.rate
      })
        .then(() => {
          this.$noty.success(this.$tr('videoresume.feedback'));
        })
        .catch(() => {
          this.$noty.error(this.$tr('common.error'));
        });
    }
  },
  async created() {
    this.$store.registerModule(STORE_PREFIX + 'interview', store);

    await this.$store.dispatch(STORE_PREFIX + 'interview/loadResponse', this.token);
    await this.$store.dispatch(STORE_PREFIX + 'interview/load', this.token);
    if (this.interview && this.videoResponse) {
      this.link = `${this.link}${this.videoResponse}`;
    }
  },
  destroyed() {
    this.$store.unregisterModule(STORE_PREFIX + 'interview');
  }
}
</script>

<style lang="scss" scoped>
  .videoresume-wrapper {
    width: 100%;
    margin: 0 auto;
    background: #fff;
    padding: 0 127px;
    max-width: 668px;

    @media (max-width: 768px) {
      padding: 0 20px;
    }
  }
</style>